<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Økonomi / Overblik</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Søjler</dt>
        @for (column of value.columns; track column) {
          <dd>{{'grant-admin.overview-xlsx-settings.column.' + column | translate }}</dd>
        }
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="45">
        Definitionen af rapporten <em>Økonomi &gt; Overblik</em> som indeholder alle bevilgede sager, hvor der
        enten er skyldige beløb eller har været posteringer i den valgte periode.
      </div>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <div fxFlex="45" fxLayout="column">
        <h3>Valgte søjler</h3>
        <div class="overview-xlsx-column-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
          @for (column of columns.value; track column; let idx = $index) {
            <div class="overview-xlsx-column" fxLayout="row" fxLayoutAlign="start center"
              cdkDrag>
              <button mat-icon-button><mat-icon>drag_indicator</mat-icon></button>
              <div fxFlex="grow">{{'grant-admin.overview-xlsx-settings.column.' + column | translate }}</div>
              <button mat-icon-button (click)="doRemoveColumn(idx)">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="45" fxLayout="column">
        <h3>Tilgængelige søjler</h3>
        <div class="overview-xlsx-available-list">
          @for (column of availableColumns; track column) {
            <div class="overview-xlsx-column" fxLayout="row" fxLayoutAlign="start center">
              <div fxFlex="grow">{{'grant-admin.overview-xlsx-settings.column.' + column | translate }}</div>
              <button mat-icon-button (click)="doAddColumn(column)">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
